import api from '..';

export const settingsVerificationUpdateRequest = (payload) => {
  return api.patch('/verification/settings', payload);
};

export const acceptTradeWithRestrictionsRequest = (payload) => {
  return api.patch('verification/settings/accept', payload);
};
